// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_do-2";
export var aiChatCartContainerExit = "_do-4";
export var aiChatContainerLarge = "_do-0";
export var aiChatContainerSmall = "_do-1";
export var aiChatIcon = "_do-6";
export var slideInFromRight = "_do-3";
export var slideOutToRight = "_do-5";